module.exports = function anonymous(it
/*``*/) {
var out='<div class="'+( it.controls)+'"> <div class="'+( it.hideEmptyCheckbox)+'"> <label> <input type="checkbox" name="hide-empty" checked="checked" /> Hide empty attributes </label> </div> <div class="'+( it.closeButton)+'"> <span close>&times;</span> </div></div><div class="'+( it.table)+'"> <table> <tbody table></tbody> </table></div>';return out;
}


//////////////////
// WEBPACK FOOTER
// ./lib/Attributes.dot
// module id = 18
// module chunks = 0